import { TabStyles } from '@tableau/widgets';
import { CSSProperties } from 'react';

const BorderWidth = 1;

const picker: CSSProperties = {
  height: `${(BorderWidth + 3) * 2 + (4 * 2 + TabStyles!.Sizing!.RowHeight!) * 2}px`, // Taken from ChipPicker's calculation of maxHeight
};

const icon: CSSProperties = {
  marginRight: TabStyles!.Spacing!.DefaultSpace,
  overflow: 'initial',
  fill: '#C93A47',
};

const errorDiv: CSSProperties = {
  color: '#C93A47',
  verticalAlign: 'baseline',
  lineHeight: '21px',
};

export { errorDiv, icon, picker };
